import styled from 'styled-components';

export const StyledTitle = styled.h1`
    display: flex;
    font-family: var(--headings-font-family);
    font-size:2rem;
    font-weight: 600;
    top: 0;
    margin: 0 1rem;
    text-align: center;
    padding: 1rem 0;
    word-wrap: break-word;
;`